// extracted by mini-css-extract-plugin
export var mt0 = "textarea-module--mt-0--95610";
export var mt1 = "textarea-module--mt-1--e6f80";
export var mt2 = "textarea-module--mt-2--21eb9";
export var mt3 = "textarea-module--mt-3--3388e";
export var mt4 = "textarea-module--mt-4--af0f6";
export var mt5 = "textarea-module--mt-5--0f5a9";
export var mt6 = "textarea-module--mt-6--85323";
export var textarea = "textarea-module--textarea--1a3a2";
export var textareaDark = "textarea-module--textarea--dark--01447";
export var textareaDisabled = "textarea-module--textarea--disabled--412da";
export var textareaError = "textarea-module--textarea--error--969f7";
export var textareaFocused = "textarea-module--textarea--focused--4d115";
export var textareaSuccess = "textarea-module--textarea--success--ef3c4";
export var textareaTransparent = "textarea-module--textarea--transparent--99d83";
export var textarea__icon = "textarea-module--textarea__icon--fb50f";
export var textarea__iconWrapper = "textarea-module--textarea__icon-wrapper--bd756";
export var textarea__input = "textarea-module--textarea__input--f94df";
export var textarea__wrapper = "textarea-module--textarea__wrapper--81a52";